import React, { useContext } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css"; // Import the Global CSS
import BannerImage from "./env2.jpeg";

const Environmental = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/environmental');
    } else {
      // Redirect to login, but save the intended destination
      navigate('/login', { state: { from: '/booking/environmental' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO HEADER --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">General Safety Module</span>
          <h1 className="hero-title">Environmental Safety</h1>
          <p className="hero-subtitle">
            Protecting our planet is not just a choice, but a necessity. Learn the principles
            of ISO 14001, pollution prevention, and sustainable industrial practices.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT LAYOUT --- */}
        <div className="detail-content">

          {/* Main Article */}
          <div className="content-article">
            {/* ... article sections ... */}
            <div className="article-section">
              <h2 className="article-heading">Basic Elements of Environment</h2>
              <p className="article-text">
                The environment comprises living (biotic) and non-living (abiotic) components working in harmony.
                Key elements include the <strong>Lithosphere</strong> (crust), <strong>Hydrosphere</strong> (water),
                <strong>Atmosphere</strong> (air), and <strong>Biosphere</strong> (life).
                Understanding these interconnections is the first step toward effective conservation and
                industrial responsibility.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Pollution & Prevention</h2>
              <p className="article-text">
                Pollution introduces harmful contaminants into these delicate systems.
                <br /><br />
                <strong>Prevention Strategies:</strong><br />
                We focus on "Cleaner Production" techniques—eliminating waste at the source rather than
                treating it at the end of the pipe. This includes sustainable waste management,
                scrubber technologies for air emissions, and strict effluent treatment protocols.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">ISO 14001 Certification</h2>
              <p className="article-text">
                ISO 14001 sets the global standard for Environmental Management Systems (EMS).
                It provides a framework for organizations to demonstrate their commitment to sustainability.
                Certification not only ensures regulatory compliance but also enhances brand reputation
                and operational efficiency by reducing waste and energy costs.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Operational Control Procedures</h2>
              <p className="article-text">
                Operational Controls are the "Standard Operating Procedures" (SOPs) for the environment.
                They dictate exactly how tasks—like chemical handling or waste disposal—must be performed
                to minimize impact. Rigorous adherence to these controls is the backbone of any
                successful EMS.
              </p>
            </div>

          </div>

          {/* Sidebar */}
          <div className="content-sidebar">

            <div className="sidebar-widget">
              <h4 className="widget-title">Key Takeaways</h4>
              <ul className="key-list">
                <li><FaCheckCircle className="check-icon" /> Understanding Biotic/Abiotic factors</li>
                <li><FaCheckCircle className="check-icon" /> ISO 14001 Framework mastery</li>
                <li><FaCheckCircle className="check-icon" /> Pollution Prevention Hierarchy</li>
                <li><FaCheckCircle className="check-icon" /> Waste Management Protocols</li>
                <li><FaCheckCircle className="check-icon" /> Emergency Response for Spills</li>
              </ul>
            </div>

            <div className="sidebar-widget">
              <h4 className="widget-title">Why it Matters</h4>
              <p style={{ color: '#aaa', lineHeight: '1.6', fontSize: '0.9rem' }}>
                Industrial accidents don't just hurt people; they damage the ecosystem for decades.
                Proactive environmental safety is the hallmark of a responsible, modern enterprise.
              </p>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Ready to Certify?</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Secure your spot in the next certification batch.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default Environmental;
